export default "__VITE_ASSET__DeqaN18d__"